import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag: (key: string, trackingId: string, config: { page_path: string }) => void;
  }
}

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;

    // Track page view
    if (window.gtag) {
      window.gtag("config", "G-32H5EJ5LMB", {
        page_path: pathname,
      });
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics;
